import AppForm from '../app-components/Form/AppForm';

Vue.component('app-farmer-driver-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                vehicle_number:  '' ,
                driver_name:  '' ,
                farmer_name:  '' ,
                enabled:  true ,
                returnJson:  false ,
                code:  '' ,
                
            }
        }
    },
    props:{
        returnJson: {
            type: Boolean,
            default: false
        },
        
    },
    mounted: function () {  
        this.form.returnJson = this.returnJson
    },
    methods:{
        onSuccess: function onSuccess(data) {
            this.submiting = false;
            if (this.form.returnJson) {
                this.$modal.hide('form-farmer')
                this.$notify({
                    type: 'sucess',
                    title: 'Success',
                    text: data.message,
                    position:"top center"
                  });
                return false;
            }
            if (data.redirect) {
              window.location.replace(data.redirect);
            }
          }
    }

});